/**
 * 템플릿 레지스트리 — componentId → React 컴포넌트 매핑
 */

import type { ComponentType } from 'react'
import type { TemplateProps } from './types.js'
import { ClassicTemplate } from './ClassicTemplate.js'
import { ModernTemplate } from './ModernTemplate.js'

const TEMPLATE_REGISTRY: Record<string, ComponentType<TemplateProps>> = {
  classic: ClassicTemplate,
  modern: ModernTemplate,
}

/** componentId로 템플릿 컴포넌트를 반환. 없으면 classic fallback. */
export function getTemplateComponent(componentId: string): ComponentType<TemplateProps> {
  return TEMPLATE_REGISTRY[componentId] ?? TEMPLATE_REGISTRY.classic
}

export type { TemplateProps } from './types.js'
export type { BlockProps } from './types.js'
